// 左侧「投资理财助手」对话框的总开关。
// 2026-10-12 用户决定所有页面都不要对话框：入口收起，代码和能力全部保留
// （useOverviewAgent / SingleAssetAgentDev / AgentChatPanel 照旧在，只是不再渲染）。
// 要恢复：改成 true。恢复前先看 docs/sdd/astock-agent-v07-single-asset-agent-behavior/parked-agent-panel.md。
export const AGENT_PANEL_ENABLED = false;
